<template>
    <div>
        <a
            :class="[
                'base-button base-button--ghost',
                disabled && 'base-button--disabled'
            ].filter(Boolean)"
            :href="fileUrl"
            :download="fileName"
        >
            <span class="base-button__label">Download ICS</span>
            <svg class="base-button__icon">
                <use xlink:href="#icon-download" />
            </svg>
        </a>
    </div>
</template>

<script>
export default {
    name: 'ICSDownloadButton',

    props: {
        eventUrl: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
        },
    },

    computed: {
        fileName(){
            const title = new URL(this.eventUrl).pathname.split('/').filter(v => !!v).pop()
            return `${title.replace(/\s/g, '-').toLocaleLowerCase()}.ics`
        },
        fileUrl(){
            return `${this.eventUrl}?ics`
        },
    },

}
</script>
